const styles = (theme) => ({
    boxFirstAccess: {
        maxWidth: '400px',
        textAlign: 'center',
        '& h2': {
            fontSize: '25px',
            fontWeight: '100',
            margin: '0 0 10px 0',
        },
        '& p': {
            lineHeight: '160%',
        },
        '& p strong': {
            fontWeight: '500',
        },
    },
    search: {
        marginBottom: '15px',
        borderRadius: '5px',
        padding: '10px 20px',
    },
    alerts: {
        marginBottom: '24px',
    },
    containerAlert: {
        order: 1,
        [theme.breakpoints.up('md')]: {
            order: 0,
        },
    },
    containerRequest: {
        order: 0,
        [theme.breakpoints.up('md')]: {
            order: 1,
        },
    },
});

export default styles;
